var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticStyle: { padding: "15px" } }, [
    _vm.roleRules.STUDENT_INFO_FLG === "Y" &&
    Object.keys(_vm.selectedStudent).length > 0
      ? _c(
          "div",
          [
            _c("h2", [
              _vm._v(
                _vm._s(_vm.selectedStudent.NAME) +
                  " (" +
                  _vm._s(_vm.selectedStudent.STUDENT_ID) +
                  ")"
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.studentInformation, function(school, index) {
              return _c(
                "div",
                { key: school.ENROLLMENT.SCHOOL_ID + "_" + index },
                [
                  _c("h4", [
                    school.ENROLLMENT.STATUS_FLG === "N"
                      ? _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.StudentInformation.sideMenuGradeLabelNotEnrolled",
                                  {
                                    school: school.ENROLLMENT.SCHOOL_TITLE,
                                    grade: school.ENROLLMENT.GRADE_LEVEL
                                  }
                                )
                              ) +
                              "\n\t\t\t\t"
                          )
                        ])
                      : _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.StudentInformation.sideMenuGradeLabelEnrolled",
                                  {
                                    school: school.ENROLLMENT.SCHOOL_TITLE,
                                    grade: school.ENROLLMENT.GRADE_LEVEL
                                  }
                                )
                              ) +
                              "\n\t\t\t\t"
                          )
                        ])
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.showCounselorData(school)
                    ? [
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          _c("div", { staticClass: "col-sm-4" }, [
                            _c("strong", [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.StudentInformation.counselorWithColon"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(school.ENROLLMENT.COUNSELOR_NAME) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      [
                        !!school.ENROLLMENT.HOME_ROOM
                          ? _c("div", { staticClass: "col-sm-4" }, [
                              _c("strong", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.StudentInformation.homeroomWithColon"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(school.ENROLLMENT.HOME_ROOM) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !!school.ENROLLMENT.STAFF_NAME
                          ? _c("div", { staticClass: "col-sm-4" }, [
                              _c("strong", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "MAIN_CONTENT.StudentInformation.teacherWithColon"
                                      )
                                    ) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ]),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(school.ENROLLMENT.STAFF_NAME) +
                                  "\n\t\t\t\t\t"
                              )
                            ])
                          : _vm._e()
                      ],
                      _vm._v(" "),
                      !!school.ENROLLMENT.TEAM_DESC &&
                      _vm.roleRules.STUDENT_INFO_TEAM_FLG === "Y"
                        ? _c("div", { staticClass: "col-sm-4" }, [
                            _c("strong", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t(
                                      "MAIN_CONTENT.StudentInformation.team"
                                    )
                                  ) +
                                  "\n\t\t\t\t\t"
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(school.ENROLLMENT.TEAM_DESC) +
                                "\n\t\t\t\t"
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm-4" }, [
                        _c("strong", [
                          _vm._v(
                            "\n\t\t\t\t\t\t" +
                              _vm._s(
                                _vm.$t(
                                  "MAIN_CONTENT.StudentInformation.learningGroup"
                                )
                              ) +
                              "\n\t\t\t\t\t"
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(school.ENROLLMENT.LEARNING_GROUP_DESC) +
                            "\n\t\t\t\t"
                        )
                      ])
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.showLockerData(school)
                    ? [
                        _c("hr"),
                        _vm._v(" "),
                        _c("div", { staticClass: "row" }, [
                          !!school.ENROLLMENT.LOCKER_NO
                            ? _c("div", { staticClass: "col-sm-4" }, [
                                _c("strong", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.StudentInformation.lockerWithColon"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(school.ENROLLMENT.LOCKER_NO) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !!school.ENROLLMENT.LOCKER_LOCATION
                            ? _c("div", { staticClass: "col-sm-4" }, [
                                _c("strong", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.StudentInformation.locationWithColon"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(school.ENROLLMENT.LOCKER_LOCATION) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !!school.ENROLLMENT.LOCKER_COMBINATION &&
                          _vm.roleRules.STUDENT_INFO_LOCKER_COMB_FLG === "Y"
                            ? _c("div", { staticClass: "col-sm-4" }, [
                                _c("strong", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          "MAIN_CONTENT.StudentInformation.combinationWithColon"
                                        )
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(
                                  "\n\t\t\t\t\t\t" +
                                    _vm._s(
                                      school.ENROLLMENT.LOCKER_COMBINATION
                                    ) +
                                    "\n\t\t\t\t\t"
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showBusingDetails(school.TRANSPORTATION)
                    ? _c("busing-details", {
                        attrs: {
                          busingDetails: school.TRANSPORTATION,
                          busPeriods: _vm.getBusingPeriods(
                            school.TRANSPORTATION
                          )
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showBuildingInfo(school)
                    ? _c("building-information", {
                        attrs: {
                          buildingInformation: school.SCHOOL,
                          adminInfo: school.ADMINISTRATORS
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br")
                ],
                2
              )
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    Object.keys(_vm.selectedStudent).length === 0
      ? _c("div", [
          _vm._v(
            "\n\t\t" +
              _vm._s(
                _vm.$t(
                  "MAIN_CONTENT.commonContent.noStudentHasBeenSelectedWithPeriod"
                )
              ) +
              "\n\t"
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }